module.exports = __webpack_public_path__ + "img/ring_memoires.7317337.jpg";